import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListDownloadHeader = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/GetListDownloadHeader`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DownloadFile = async (param) => {
  let url = `${API_URL.Loader}/api/Decrypt/DownloadFile`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};


